/* Modal — overlay dialog with title, subtitle, body, footer, and Escape-to-close.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12).
   NOTE: close button uses native <button className="btn ..."> per ticket 1.4 concurrency
   rules (Button component lives in ticket 1.3's worktree). */

import React, { useEffect } from 'react';
import { Icon } from './Icon';

export interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
}

export function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  width = 480,
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const h = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose && onClose();
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
    >
      <div className="modal" style={{ maxWidth: width }}>
        <div className="modal-header">
          <div>
            <div className="modal-title">{title}</div>
            {subtitle && (
              <div
                className="text-secondary"
                style={{ fontSize: 'var(--fs-sm)', marginTop: 3 }}
              >
                {subtitle}
              </div>
            )}
          </div>
          {/* Native button matching btn btn-ghost btn-icon btn-sm — no Button import per concurrency rules */}
          <button
            className="btn btn-ghost btn-icon btn-sm"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="x" size={16} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default Modal;
